/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo";

// Must precede the pusher-js import so it snapshots window.Pusher first.
import { hadPusher, priorPusher } from "@/services/pusherGlobalGuard";

import Pusher from "pusher-js";

// pusher-js's web build assigns window.Pusher (v8) on import. We never use the
// global — Echo gets Pusher passed locally below. Chatlio's widget owns
// window.Pusher for its own realtime; our v8 (missing Util.extend) breaks it.
// Restore the global to exactly what it was so we never clobber Chatlio.
if (hadPusher) window.Pusher = priorPusher;
else delete window.Pusher;

window.Echo = new Echo({
  broadcaster: "pusher",
  Pusher,
  key: import.meta.env.VITE_PUSHER_APP_KEY,
  cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
  // wsHost: window.location.hostname,
  wsHost: import.meta.env.VITE_PUSHER_APP_HOST,
  wsPort: import.meta.env.VITE_PUSHER_APP_PORT,
  wssPort: import.meta.env.VITE_PUSHER_APP_PORT,
  disableStats: true,
  forceTLS: true,
});
